import React, { useState, useEffect, useRef, useContext, useCallback } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import './final-report-container.scss';
import { default as t } from '../../../utils/i18n';
import { ReactComponent as DownloadIcon } from '../../../assets/svg/Download-icon.svg';
import CampaingPerformance from '../campaing-performance/campaing-performance';
import ActualAndPlanned from '../actual-and-planned/actual-and-planned';
import { Panel } from 'rsuite';
import SocialResultContainer from '../social-result-container/social-result-container';
import TopPostsContainer from '../top-posts-container/top-posts-container';
import StartStopContainer from '../start-stop-container/start-stop-container';
import StretargyOverview from '../stratergy-overview/stratergy-overview';
import { ToasterContext, UserContext } from '../../../context';
import { ReportsService } from '../../../services';
import html2canvas from 'html2canvas';
import jsPdf from 'jspdf';
import { Popover, Whisper, Dropdown } from 'rsuite';
import queryString from 'query-string';
import { CommonToaster, Loader, AppTooltip } from '../../atoms';
import fileDownload from 'js-file-download';
import axios from '../../../utils/axios';
import axiosStat from 'axios';
import { DndContext, closestCenter, useSensor, useSensors, MouseSensor } from '@dnd-kit/core';
import { arrayMove, SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { SortableItem } from '../../atoms/sortableItem/sortableItem';
import canvasSize from 'canvas-size';
import FinalReportGraph from '../final-report-graph/final-report-graph';

function FinalReportContainer() {
  const [dashData, setDashData] = useState({});
  const [openSliderModal, setOpenSliderModal] = useState(false);
  const triggerRef = React.useRef();
  const params = useParams();
  const history = useHistory();
  const [kpiList, setKpiList] = useState([]);
  const [aurthorizedStatus, setAurthorizedStatus] = useState(false);
  const handleBackClick = e => {
    history.push('/reports');
  };
  const { user, setUser } = useContext(UserContext);
  const userAccessToken = user?.tokens?.accessToken?.jwtToken;
  const username = user?.username;
  const [data, setData] = useState({});
  const [isEdit, setIsEdit] = useState(false);
  const panelNameMapping = {
    current_vs_last: t('report.output.current.cycle'),
    strategy_overview: t('report.output.strategy.overview'),
    actual_vs_planned: t('report.output.actual.planned'),
    breakdown: '',
    top_posts: t('report.output.top.posts'),
    low_posts: t('final-report.low.posts'),
    optimisations: t('report.output.SSC'),
  };
  const [orderArr, setOrderarr] = React.useState([]);
  const [loader, setLoader] = useState(null);
  const NEW_ORDER = useRef([]);
  const location = queryString?.parse(window.location.search);
  const reportId = location?.reportId;
  const cycleId = location?.cycleId;
  const [panels, setPanels] = useState([]);

  const { message, setMessage } = useContext(ToasterContext);
  const [toaster, setToaster] = useState(false);
  const [snapShotUrls, setSnapShotUrls] = useState([]);
  const [isReRender, setIsRerender] = useState(true);

  const handleViewClick = () => {
    setOpenSliderModal(true);
  };
  const handleOpenSliderModal = () => {
    setOpenSliderModal(false);
  };

  const handleDownloadSSClick = async icon => {
    try {
      const response = await ReportsService.getTopAds(userAccessToken, username, reportId, cycleId);
      setSnapShotUrls(response?.data?.data);
    } catch (error) {
      setSnapShotUrls(data?.reportData?.top_performing_ads);
    }
    setLoader(true);
    setTimeout(() => {
      var x = document.getElementById('snapshot-container')?.querySelectorAll('.rs-table-row');
      x?.forEach(el => {
        const rowIndex = el?.attributes?.['aria-rowindex']?.value;
        if (rowIndex > 2) {
          let marginPX = el.style.transform.substring(
            el.style.transform.indexOf(',') + 1,
            el.style.transform.lastIndexOf(',')
          );
          el.style.transform = 'none';
          el.style.marginTop = marginPX;
        }
      });
      const snapshotDiv = document.getElementById('snapshot-container');
      html2canvas(snapshotDiv, { useCORS: true, allowTaint: true, scrollY: 0 }).then(canvas => {
        // Calculate the number of pages.
        let pxFullHeight = canvas.height;

        // check for canvas height is not exceeding
        let isValidCanvas = canvasSize.test({
          width: canvas.width,
          height: pxFullHeight,
        });
        if (isValidCanvas) {
          const image = { type: 'jpeg', quality: 0.98 };
          const margin = [0.3, 0.5];
          let imgWidth = 8.5;
          let pageHeight = 11;
          let innerPageWidth = imgWidth - margin[0] * 2;
          let innerPageHeight = pageHeight - margin[1] * 2;
          let pxPageHeight = Math.floor(canvas.width * (pageHeight / imgWidth));
          let nPages = Math.ceil(pxFullHeight / pxPageHeight);

          // Define pageHeight separately so it can be trimmed on the final page.
          let sepratePageHeight = innerPageHeight;

          // Create a one-page canvas to split up the full image.
          let pageCanvas = document.createElement('canvas');
          let pageCtx = pageCanvas.getContext('2d');
          pageCanvas.width = canvas.width;
          pageCanvas.height = pxPageHeight;

          // Initialize the PDF.
          let pdf = new jsPdf('p', 'in', [8.5, 11]);

          for (let page = 0; page < nPages; page++) {
            // Trim the final page to reduce file size.
            if (page === nPages - 1 && pxFullHeight % pxPageHeight !== 0) {
              pageCanvas.height = pxFullHeight % pxPageHeight;
              sepratePageHeight = (pageCanvas.height * innerPageWidth) / pageCanvas.width;
            }

            // Display the page.
            let w = pageCanvas.width;
            let h = pageCanvas.height;
            pageCtx.fillStyle = 'white';
            pageCtx.fillRect(0, 0, w, h);
            pageCtx.drawImage(canvas, 0, page * pxPageHeight, w, h, 0, 0, w, h);

            // Add the page to the PDF.
            if (page > 0) pdf.addPage();
            let imgData = pageCanvas.toDataURL('image/' + image.type, image.quality);
            pdf.addImage(
              imgData,
              image.type,
              margin[1],
              margin[0],
              innerPageWidth,
              sepratePageHeight
            );
          }

          pdf.save(`${reportId}_${data?.reportingStartDate}_${data?.reportingEndDate}.pdf`);
        } else {
          setTheMessages({ message: t('final.output.pdf.fail'), isError: true });
        }
        icon.classList.remove('active');
        setLoader(false);
      });
    }, 1000);
  };

  const downloadExcel = async icon => {
    try {
      const response = await ReportsService.downloadXcel(
        userAccessToken,
        username,
        reportId,
        cycleId
      );
      const url = new URL(response?.data?.data);
      const fileName = url.pathname.replace(/^.*[\\\/]/, '');
      const api = axiosStat.create({
        baseURL: axios.defaults.baseURL.slice(0, -4),
      });
      api
        .get(url, {
          responseType: 'blob',
        })
        .then(res => {
          fileDownload(res.data, fileName);
        });
      icon.classList.remove('active');
    } catch (error) {
      const dataCode = error?.data?.data?.code;
      icon.classList.remove('active');
      if (dataCode) {
        //console.log(dataCode);
      }
    }
  };

  const updateReportPreference = async (type, commentry = {}, breakdownId = '') => {
    try {
      const requestData = {
        reportId: reportId,
        cycleId: cycleId,
        type: type,
        data: {},
      };
      if (type === 'output_section') {
        requestData.data.output_sections_order = NEW_ORDER.current.map(x => {
          let name = '';
          if (x.type === 'breakdown') {
            name = 'breakdown_' + x.id;
          } else {
            name = x.type;
          }
          return name;
        });
      } else if (type === 'start' || type === 'stop' || type === 'continue') {
        let commentryData = [];
        commentry?.forEach(el => {
          commentryData.push({ value: el.content, show_in_export: el.show_in_export });
        });
        requestData.type = 'optimisations';
        requestData.data = {
          level: type,
          optimisations: commentryData,
        };
      } else {
        let commentryData = [];
        commentry?.forEach(el => {
          commentryData.push({ value: el.content, show_in_export: el.show_in_export });
        });
        requestData.type = 'commentary';
        requestData.data = {
          level: type,
          commentary: commentryData,
        };
        if (type === 'breakdown') {
          requestData.data.breakdownId = breakdownId;
        }
      }
      const response = await ReportsService.updateReporOutput(
        userAccessToken,
        username,
        requestData
      );
      let currentData = { ...data };
      if (type === 'summary') {
        currentData.reportData.commentary_to_show = requestData?.data?.commentary;
      } else if (type === 'breakdown') {
        const index = currentData.reportData.breakdowns.findIndex(item => item.id === breakdownId);
        currentData.reportData.breakdowns[index].commentary_to_show = requestData?.data?.commentary;
      } else if (type === 'planned_actual_commentary') {
        currentData.reportData.planned_actual_commentary_to_show = requestData?.data?.commentary;
      } else if (type === 'last_vs_current_commentary') {
        currentData.reportData.last_vs_current_commentary_to_show = requestData?.data?.commentary;
      } else if (requestData.type === 'optimisations') {
        currentData.reportData.optimisations_to_show[type] = requestData?.data?.optimisations;
      }
      setData(currentData);
      setIsRerender(false);
      setIsRerender(true);
    } catch (error) {
      const dataCode = error?.data?.data?.code;
      if (dataCode) {
        //console.log(dataCode);
      }
    }
  };
  const cardComponent = (props, fromSnapShot) => {
    switch (props?.type) {
      case 'current_vs_last':
        return (
          <CampaingPerformance
            data={data}
            kpiList={kpiList}
            setData={setData}
            updateReportPreference={updateReportPreference}
            isEdit={isEdit}
            fromSnapShot={fromSnapShot}
          />
        );
      case 'actual_vs_planned':
        return (
          <ActualAndPlanned
            data={data}
            kpiList={kpiList}
            setData={setData}
            updateReportPreference={updateReportPreference}
            isEdit={isEdit}
            fromSnapShot={fromSnapShot}
          />
        );
      case 'breakdown':
        return (
          <SocialResultContainer
            data={data && data?.reportData?.breakdowns.filter(x => x.id === props.id)}
            setData={setData}
            kpiList={kpiList}
            updateReportPreference={updateReportPreference}
            isEdit={isEdit}
            fromSnapShot={fromSnapShot}
            currency={data?.currency}
          />
        );
      case 'top_posts':
        return (
          <TopPostsContainer
            data={data}
            kpiList={kpiList}
            setData={setData}
            fromSnapShot={fromSnapShot}
            snapShotUrls={snapShotUrls}
          />
        );
      case 'low_posts':
        return (
          <TopPostsContainer
            data={data}
            kpiList={kpiList}
            setData={setData}
            fromSnapShot={fromSnapShot}
            snapShotUrls={snapShotUrls}
            isLowPosts={true}
          />
        );
      case 'low_posts':
          return (
            <TopPostsContainer
              data={data}
              kpiList={kpiList}
              setData={setData}
              fromSnapShot={fromSnapShot}
            snapShotUrls={snapShotUrls}
            isLowPosts = {true}

            />
          );
      case 'optimisations':
        return (
          <StartStopContainer
            data={data}
            setData={setData}
            isEdit={isEdit}
            fromSnapShot={fromSnapShot}
            updateReportPreference={updateReportPreference}
          />
        );
      case 'strategy_overview':
        return <StretargyOverview data={data} setData={setData} />;
      default:
        return '';
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    getKpiList();
    getFinalReport(params?.reportId, params?.cycleId);
  }, []);

  async function getKpiList() {
    try {
      const kpiListResponse = await ReportsService.getKpiMetrics(userAccessToken, username);
      setKpiList(list => [...list, ...kpiListResponse?.data?.data]);
    } catch (error) {
      const dataCode = error?.data?.data?.code;
      if (dataCode) {
        //console.log(dataCode);
      }
    }
  }

  async function getFinalReport() {
    let panelOrder = [];
    try {
      setLoader(true);
      const response = await ReportsService.getFinalReport(
        userAccessToken,
        username,
        reportId,
        cycleId
      );
      const reportData = response?.data?.data;
      const cusMetricData = await ReportsService.getCustomDict(
        userAccessToken,
        username,
        reportData?.advertiser
      );
      setUser(prevUser => ({
        ...user,
        selectedAdvertiser: reportData?.advertiser,
        selectedAdaccounts: reportData?.campaigns?.length
          ? reportData?.campaigns[0]?.accountId
          : '',
      }));
      setKpiList(list => [...list, ...cusMetricData?.data?.data]);
      setLoader(false);
      setData(reportData);
      reportData?.reportData?.output_sections_order?.forEach(el => {
        panelOrder.push({
          title: el?.includes('breakdown') ? '' : panelNameMapping[el],
          type: el?.includes('breakdown') ? 'breakdown' : el,
          id: el?.includes('breakdown') ? el?.slice(10) : '',
        });
      });
      reportData &&
        reportData?.reportData?.breakdowns.map(idx => {
          panelOrder.forEach(el => {
            if (el.id === idx?.id) {
              el.title = idx.title;
            }
          });
        });
      if (reportData?.type === 'EOCR') {
        const overViewIndex = panelOrder.findIndex(el => el.type === 'strategy_overview');
        const currentIndex = panelOrder.findIndex(el => el.type === 'current_vs_last');
        overViewIndex != -1 && panelOrder.splice(overViewIndex, 1);
        currentIndex != -1 && panelOrder.splice(currentIndex, 1);
      }
      if (reportData?.type === 'LIVE') {
        const overViewIndex = panelOrder.findIndex(el => el.type === 'strategy_overview');
        overViewIndex != -1 && panelOrder.splice(overViewIndex, 1);
      }
      if (reportData?.type === 'PCA') {
        const currentIndex = panelOrder.findIndex(el => el.type === 'current_vs_last');
        currentIndex != -1 && panelOrder.splice(currentIndex, 1);
      }
      setOrderarr([...panelOrder]);
      let commentary = [];
      reportData?.reportData?.commentary_to_show?.forEach((list, index) =>
        commentary.push({
          id: index,
          content: list.value,
          editable: false,
          show_in_export: list.show_in_export,
        })
      );
      setPanels([...commentary]);
    } catch (error) {
      setLoader(false);
      let msg = '';
      if (error && error !== null) {
        msg = t(error?.data?.data?.message);
        if (401 === error?.data?.data?.status) {
          setAurthorizedStatus(true);
        } else {
          setTheMessages({ message: msg, isError: true });
        }
      }
    }
  }
  const MultiplePanels = ({ fromSnapShot }) => {
    const mouseSensor = useSensor(MouseSensor, {
      activationConstraint: {
        distance: 10, // Enable sort function when dragging 10px   💡 here!!!
      },
    });
    const sensors = useSensors(mouseSensor);
    function handleDragEnd(event) {
      const { active, over } = event;

      if (active.id !== over.id) {
        const oldIndex = panels.findIndex(x => x.id === active.id);
        const newIndex = panels.findIndex(x => x.id === over.id);
        const newArray = arrayMove(panels, oldIndex, newIndex);
        updatePanelsData(newArray);
      }
    }

    const updatePanelsData = (comentryData, type = '') => {
      setPanels(comentryData);
      if (type !== 'edit') {
        updateReportPreference('summary', comentryData);
      }
    };

    return (
      <>
        {isEdit ? (
          <DndContext
            sensors={sensors}
            collisionDetection={closestCenter}
            onDragEnd={handleDragEnd}
            autoScroll={false}
          >
            <SortableContext items={panels} strategy={verticalListSortingStrategy}>
              {panels.map(item => (
                <SortableItem
                  data={item}
                  isEdit={isEdit}
                  panels={panels}
                  fromSnapShot={fromSnapShot}
                  setPanels={(data, type) => updatePanelsData(data, type)}
                />
              ))}
            </SortableContext>
          </DndContext>
        ) : (
          <div>
            {panels.map(item =>
              !item?.show_in_export && fromSnapShot ? (
                ''
              ) : (
                <SortableItem
                  data={item}
                  isEdit={isEdit}
                  panels={panels}
                  setPanels={(data, type) => updatePanelsData(data, type)}
                />
              )
            )}
          </div>
        )}
      </>
    );
  };

  const Card = useCallback(
    fromSnapShot => {
      const reorderArray = (event, originalArray) => {
        const movedItem = originalArray.find((item, index) => index === event.oldIndex);
        const remainingItems = originalArray.filter((item, index) => index !== event.oldIndex);

        const reorderedItems = [
          ...remainingItems.slice(0, event.newIndex),
          movedItem,
          ...remainingItems.slice(event.newIndex),
        ];
        NEW_ORDER.current = reorderedItems;
        return reorderedItems;
      };

      async function changeOrder(index, direction) {
        setOrderarr(
          reorderArray(
            { oldIndex: index, newIndex: index + (direction === 'UP' ? -1 : 1) },
            orderArr
          )
        );
        updateReportPreference('output_section');
      }

      return orderArr.map((item, index) => {
        return (
          <Panel bordered key={index + 'card'}>
            <div className="title-Container">
              <h3>{item.title}</h3>
              {isEdit ? (
                <div className="order">
                  {index !== 0 ? (
                    <i
                      title="Move upward"
                      className="eva  eva-arrow-upward-outline"
                      onClick={() => changeOrder(index, 'UP')}
                    ></i>
                  ) : (
                    ''
                  )}
                  {index + 1 < orderArr?.length ? (
                    <i
                      title="Move downward"
                      className="eva  eva-arrow-downward-outline"
                      onClick={() => changeOrder(index, 'DOWN')}
                    ></i>
                  ) : (
                    ''
                  )}
                </div>
              ) : (
                ''
              )}
            </div>
            {cardComponent(item, fromSnapShot)}
          </Panel>
        );
      });
    },
    [orderArr, isEdit, snapShotUrls]
  );

  const setTheMessages = message => {
    if (message?.message) {
      setMessage({});
      setMessage(message);
      setToaster(true);
      clearToaster();
    } else {
      setToaster(false);
      setMessage({});
    }
  };

  let clearToaster = () => {
    setTimeout(() => {
      setToaster(false);
    }, 7000);
  };

  const handleSelect = eventKey => {
    const icon = document.querySelector('.download-icon');
    icon.classList.add('active');
    console.log(eventKey);
    triggerRef.current.close();
    setTimeout(() => {
      if (eventKey === 'pdf') {
        handleDownloadSSClick(icon);
      } else {
        downloadExcel(icon);
      }
    }, 100);
  };
  const handleEditClick = event => {
    setIsEdit(val => !val);
  };
  return (
    <>
      {loader ? <Loader /> : null}
      <CommonToaster message={message} toaster={toaster}></CommonToaster>
      <section
        className={aurthorizedStatus ? 'final-report unaurthorized-report' : 'reportDisplaynone'}
      >
        <div className="heading-btn-container">
          <button className="return-insights" onClick={() => handleBackClick()}>
            <i className="eva  eva-arrow-ios-back-outline"></i>
            {t('final.output.backto.report')}
          </button>
        </div>
        <div className="lock-icon">
          <span>
            <i className="eva eva-lock-outline"> </i>
          </span>
          <p className="mgs-unaurthorized-report">{t('final.output.unaurthorized.mgs')}</p>
        </div>
      </section>
      <div className={aurthorizedStatus ? 'reportDisplaynone' : ''}>
        <section className="final-report">
          <div className="heading-btn-container">
            <button className="return-insights" onClick={() => handleBackClick()}>
              <i className="eva  eva-arrow-ios-back-outline"></i>
              {t('define.report.stepper.button.back')}
            </button>
          </div>
          <div>
            <div className="head-title">
              <span>
                {data?.type} {t('final.output.campaign.report')}:&nbsp;
                <b>{data?.reportName}</b>
              </span>
            </div>
            <div className="action-items">
              <div className="button-row">
                <DownloadIcon className="download-icon" />
                {data?.reportData?.metrics_for_graph?.length > 0 && (
                  <div className="edit-button" onClick={handleViewClick}>
                    {t('graph.view')}
                  </div>
                )}
                <div className="edit-button" onClick={handleEditClick}>
                  {isEdit ? t('final.output.save') : t('final.output.enable.editing')}
                </div>
                <div className={isEdit ? 'round disabled' : 'round'}>
                  <Whisper
                    placement="leftStart"
                    trigger={isEdit ? 'none' : 'click'}
                    ref={triggerRef}
                    speaker={
                      <Popover className={'className'} full>
                        <Dropdown.Menu onSelect={handleSelect}>
                          <Dropdown.Item eventKey={'excel'}>
                            {t('final.output.download.excel')}
                          </Dropdown.Item>
                          <Dropdown.Item eventKey={'pdf'}>
                            {t('final.output.download.pdf')}
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Popover>
                    }
                  >
                    <i className="eva eva-download-outline"></i>
                  </Whisper>
                </div>
              </div>
              {data?.reportData?.metrics_for_graph?.length === 0 && (
                <div className="totalValueNote">
                  <span className="boldText">
                    {' '}
                    <i className="eva eva-info-outline"></i>
                  </span>
                  {t(
                    'graph.view.note'
                  )}{' '}
                </div>
              )}
            </div>
            <div className="card-section">
              <div className="first-card">
                <div className="left-sec">
                  <div className="title-sec">
                    <h1 title={data?.reportName}>{data?.reportName}</h1>
                    <span>
                      <i className="eva eva-pin-outline"></i>
                      <div
                        className="location"
                        title={
                          data?.location?.length > 0 ? data?.location?.join(', ').toString() : 'N/A'
                        }
                      >
                        {data?.location?.length > 0 ? data?.location?.join(', ').toString() : 'N/A'}
                      </div>
                    </span>
                  </div>
                </div>
                <div className="right-sec">
                  <div className="report-date">
                    <p>{t('reportTable.text.advertiser')}</p>
                    <span className="advertiser" title={data?.advertiser}>
                      {data?.advertiser}
                    </span>
                  </div>
                  <div className="report-date">
                    <p> {t('define.stepper.dateRange')}</p>
                    <span>
                      {data?.reportingStartDate}-{data?.reportingEndDate}
                    </span>
                  </div>
                </div>
              </div>
              <div className="second-card">
                <div className="first-row">
                  <div>
                    <p title={'Planned spend ' + data?.currency}>
                      {t('final.output.planned.spend')} ({data?.currency})
                    </p>
                    <span>{data?.plannedSpend}</span>
                  </div>
                  <div>
                    <p>
                      {t('contentTable.acutalSpent.label')} ({data?.currency})
                    </p>
                    <span>{data?.actualSpend}</span>
                  </div>
                  <div>
                    <p>{t('final.output.spend.pacing')}</p>
                    <span>{data?.spendPacing}</span>
                  </div>
                  <div>
                    <p>{t('final.output.panned.impressions')}</p>
                    <span>{data?.plannedImpressions}</span>
                  </div>
                  <div>
                    <p>{t('final.output.planned.dates')}</p>
                    <span>{data?.plannedDates}</span>
                  </div>
                </div>
                <div className="seprator"></div>
                <div className="second-row">
                  <div className="row-data">
                    <div>
                      <p title={t('final.output.days.elapsed')}>{t('final.output.days.elapsed')}</p>
                      <span title={data?.daysElapsed}>{data?.daysElapsed}</span>
                    </div>
                    <div>
                      <p title={t('final.output.days.elapsed') + ' %'}>
                        {t('final.output.days.elapsed')} %
                      </p>
                      <span title={data?.daysElapsedPercent}>{data?.daysElapsedPercent}</span>
                    </div>
                    <div>
                      <p title={t('final.output.days.remaining')}>
                        {t('final.output.days.remaining')}
                      </p>
                      <span title={data?.daysRemaining}>{data?.daysRemaining}</span>
                    </div>
                  </div>
                  <div className="devider"></div>
                  <div className="row-data">
                    <div>
                      <p title={t('define.matric.table.primaryKpi')}>
                        {t('define.matric.table.primaryKpi')}{' '}
                      </p>
                      <span
                        title={
                          data?.primaryKpi
                            ? kpiList.length > 0 &&
                              kpiList?.filter(x => x?.sys_id === data?.primaryKpi)[0]?.KPI_Metric
                            : 'N/A'
                        }
                      >
                        {data?.primaryKpi
                          ? kpiList.length > 0 &&
                            kpiList?.filter(x => x?.sys_id === data?.primaryKpi)[0]?.KPI_Metric
                          : 'N/A'}
                      </span>
                    </div>
                    <div>
                      <p title={t('final.output.primary.kpi.pacing')}>
                        {t('final.output.primary.kpi.pacing')}{' '}
                      </p>
                      <span title={data?.primaryKpiPacing}>{data?.primaryKpiPacing}</span>
                    </div>
                    <div>
                      <p title={t('final.output.primary.kpi.planned.target')}>
                        {t('final.output.primary.kpi.planned.target')}{' '}
                      </p>
                      <span title={data?.primaryKpiPlannedTarget}>
                        {data?.primaryKpiPlannedTarget}
                      </span>
                    </div>
                  </div>
                  <div className="devider"></div>
                  <div className="row-data">
                    <div>
                      <p title={t('define.matric.table.secondaryKpi')}>
                        {t('define.matric.table.secondaryKpi')}
                      </p>
                      <span
                        title={
                          data?.secondaryKpi
                            ? kpiList.length > 0 &&
                              kpiList?.filter(x => x?.sys_id === data?.secondaryKpi)[0]?.KPI_Metric
                            : 'N/A'
                        }
                      >
                        {data?.secondaryKpi
                          ? kpiList.length > 0 &&
                            kpiList?.filter(x => x?.sys_id === data?.secondaryKpi)[0]?.KPI_Metric
                          : 'N/A'}
                      </span>
                    </div>
                    <div>
                      <p title={t('final.output.secondary.kpi.pacing')}>
                        {t('final.output.secondary.kpi.pacing')}
                      </p>
                      <span title={data?.secondaryKpiPacing}>{data?.secondaryKpiPacing}</span>
                    </div>
                    <div>
                      <p title={t('final.output.secondary.kpi.planned.target')}>
                        {t('final.output.secondary.kpi.planned.target')}
                      </p>
                      <span title={data?.secondaryKpiPlannedTarget}>
                        {data?.secondaryKpiPlannedTarget}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="seprator"></div>
                <div className="third-row">
                  <div className="head-sec">
                    <p>{t('define.stepper.table.campaignName')}</p>
                    <p>{t('define.stepper.adAccount')}</p>
                    <p>{t('define.stepper.table.objective')}</p>
                    <p>{t('final.output.optimisation.goal')}</p>
                  </div>
                  <div>
                    {data?.campaigns?.map((attr, index) => (
                      <div className="content" key={index + 'camp'}>
                        <p title={attr?.campaignName}>{attr?.campaignName}</p>
                        <p title={attr?.accountName}>{attr?.accountName}</p>
                        <p title={attr?.objective}>{attr?.objective}</p>
                        <p title={attr?.optimization_goal?.length ? attr?.optimization_goal.join(', ') : 'N/A'}>{attr?.optimization_goal?.length ? attr?.optimization_goal.join(', ') : 'N/A'}</p>
                      </div>
                    ))}
                  </div>
                </div>
                {panels?.length > 0 ? (
                  <div className="insights">
                    <h3>{t('final.output.insights.title')}</h3>
                    <MultiplePanels />
                    <div className="the-insights margin-none">
                      <span className="high-light">*</span>
                      {t('report.output.insights.note')}{' '}
                    </div>
                  </div>
                ) : (
                  ''
                )}
              </div>
            </div>
            {data?.reportData?.breakdowns && <div className="card-container"> {Card(false)} </div>}
          </div>
          {openSliderModal && (
            <FinalReportGraph
              handleOpenSliderModal={handleOpenSliderModal}
              openSliderModal={openSliderModal}
              data={data}
              kpiList={kpiList}
            />
          )}
        </section>
        {isReRender && (
          <section id="snapshot-container" className="final-report">
            <div>
              <div className="head-title">
                <span>
                  {t('define.report.type.typelist.title1')}:<b>{data?.reportName}</b>
                </span>
              </div>
              <div className="card-section">
                <div className="first-card">
                  <div className="left-sec">
                    <div>
                      <h1>{data?.reportName}</h1>
                      <span>
                        <i className="eva eva-pin-outline"></i>
                        {data?.location?.length > 0 ? data?.location?.join(', ').toString() : 'N/A'}
                      </span>
                    </div>
                  </div>
                  <div className="right-sec">
                    <div className="report-date">
                      <p>{t('reportTable.text.advertiser')}</p>
                      <span>{data?.advertiser}</span>
                    </div>
                    <div className="report-date">
                      <p> {t('define.stepper.dateRange')}</p>
                      <span>
                      {data?.reportingStartDate}-{data?.reportingEndDate}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="second-card">
                  <div className="first-row">
                    <div>
                      <p>
                        {t('final.output.planned.spend')} ({data?.currency})
                      </p>
                      <span>{data?.plannedSpend}</span>
                    </div>
                    <div>
                      <p>
                        {t('contentTable.acutalSpent.label')} ({data?.currency})
                      </p>
                      <span>{data?.actualSpend}</span>
                    </div>
                    <div>
                      <p>{t('final.output.spend.pacing')}</p>
                      <span>{data?.spendPacing}</span>
                    </div>
                    <div>
                      <p>{t('final.output.panned.impressions')}</p>
                      <span>{data?.plannedImpressions}</span>
                    </div>
                    <div>
                      <p>{t('final.output.planned.dates')}</p>
                      <span>{data?.plannedDates}</span>
                    </div>
                  </div>
                  <div className="seprator"></div>
                  <div className="second-row">
                    <div className="row-data">
                      <div>
                        <p>{t('final.output.days.elapsed')}</p>
                        <span>{data?.daysElapsed}</span>
                      </div>
                      <div>
                        <p>{t('final.output.days.elapsed')} %</p>
                        <span>{data?.daysElapsedPercent}</span>
                      </div>
                      <div>
                        <p>{t('final.output.days.remaining')}</p>
                        <span>{data?.daysRemaining}</span>
                      </div>
                    </div>
                    <div className="devider"></div>
                    <div className="row-data">
                      <div>
                        <p>{t('define.matric.table.primaryKpi')} </p>
                        <span>
                          {data?.primaryKpi
                            ? kpiList.length > 0 &&
                              kpiList?.filter(x => x?.sys_id === data?.primaryKpi)[0]?.KPI_Metric
                            : 'N/A'}
                        </span>
                      </div>
                      <div>
                        <p>{t('final.output.primary.kpi.pacing')}</p>
                        <span>{data?.primaryKpiPacing}</span>
                      </div>
                      <div>
                        <p>{t('final.output.primary.kpi.planned.target')} </p>
                        <span>{data?.primaryKpiPlannedTarget}</span>
                      </div>
                    </div>
                    <div className="devider"></div>
                    <div className="row-data">
                      <div>
                        <p>{t('define.matric.table.secondaryKpi')}</p>
                        <span>
                          {data?.secondaryKpi
                            ? kpiList.length > 0 &&
                              kpiList?.filter(x => x?.sys_id === data?.secondaryKpi)[0]?.KPI_Metric
                            : 'N/A'}
                        </span>
                      </div>
                      <div>
                        <p>{t('final.output.secondary.kpi.pacing')}</p>
                        <span>{data?.secondaryKpiPacing}</span>
                      </div>
                      <div>
                        <p>{t('final.output.secondary.kpi.planned.target')}</p>
                        <span>{data?.secondaryKpiPlannedTarget}</span>
                      </div>
                    </div>
                  </div>
                  <div className="seprator"></div>
                  <div className="third-row">
                    <div className="head-sec">
                      <p>{t('define.stepper.table.campaignName')}</p>
                      <p>{t('define.stepper.adAccount')}</p>
                      <p>{t('define.stepper.table.objective')}</p>
                      <p>{t('final.output.optimisation.goal')}</p>
                    </div>
                    <div>
                      {data?.campaigns?.map((attr, index) => (
                        <div className="content" key={index + 'camp'}>
                          <p title={attr?.campaignName}>{attr?.campaignName}</p>
                          <p title={attr?.accountName}>{attr?.accountName}</p>
                          <p title={attr?.objective}>{attr?.objective}</p>
                          <p title={attr?.optimization_goal?.length ? attr?.optimization_goal.join(', ') : 'N/A'}>{attr?.optimization_goal?.length ? attr?.optimization_goal.join(', ') : 'N/A'}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                  {panels?.length > 0 ? (
                    <div className="insights">
                      <h3>{t('final.output.insights.title')}</h3>
                      <MultiplePanels fromSnapShot={true} />
                      <div className="the-insights margin-none">
                        <span className="high-light">*</span>
                        {t('report.output.insights.note')}{' '}
                      </div>
                    </div>
                  ) : (
                    ''
                  )}
                </div>
              </div>
              <div className="card-container">
                {data?.reportData?.breakdowns && (
                  <div className="card-container"> {Card(true)} </div>
                )}
              </div>
            </div>
          </section>
        )}
      </div>
    </>
  );
}

export default FinalReportContainer;
